module.exports = __webpack_public_path__ + "static/img/output2.47bf5fc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/test/output2.jpg
// module id = 176
// module chunks = 2